import { NgModule } from '@angular/core';
import { AmdHeroComponent } from './hero.component';
var AmdHeroModule = /** @class */ (function () {
    function AmdHeroModule() {
    }
    AmdHeroModule.decorators = [
        { type: NgModule, args: [{
                    declarations: [AmdHeroComponent],
                    exports: [AmdHeroComponent]
                },] },
    ];
    /**
     * @nocollapse
     */
    AmdHeroModule.ctorParameters = function () { return []; };
    return AmdHeroModule;
}());
export { AmdHeroModule };
function AmdHeroModule_tsickle_Closure_declarations() {
    /** @type {?} */
    AmdHeroModule.decorators;
    /**
     * @nocollapse
     * @type {?}
     */
    AmdHeroModule.ctorParameters;
}
//# sourceMappingURL=hero.module.js.map
//# sourceMappingURL=hero.module.js.map
